/**
 * https://schema.org/Organization
 */
export const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Zapier',
  legalName: 'Zapier Inc',
  url: 'https://zapier.com',
  logo: 'https://zapier.com/brand/assets/images/logos/zapier-logo.png',
  foundingDate: '2011',
  founders: [
    {
      '@type': 'Person',
      name: 'Bryan Helmig',
    },
    {
      '@type': 'Person',
      name: 'Wade Foster',
    },
    {
      '@type': 'Person',
      name: 'Mike Knoop',
    },
  ],
  address: {
    '@type': 'PostalAddress',
    streetAddress: '548 Market St. #62411',
    addressLocality: 'San Francisco',
    addressRegion: 'CA',
    postalCode: '94104',
    addressCountry: 'USA',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer support',
    url: 'https://zapier.com/help/',
  },
  sameAs: [
    'https://www.facebook.com/ZapierApp',
    'https://www.linkedin.com/company/zapier/',
    'https://twitter.com/zapier',
    'https://www.youtube.com/user/ZapierApp/videos',
  ],
};
